// extracted by mini-css-extract-plugin
module.exports = {"highlightContainer":"style-module__highlightContainer___Gclpq","highlight":"style-module__highlight___2gL1l"};